export interface PluralizedWording {
  one: string
  multiple: string
}

export const getPluralizedWording = (
  wording: string | PluralizedWording,
  value: number,
) => {
  if (typeof wording === "string") return wording
  if (value <= 1) return wording.one
  return wording.multiple
}
